import { parseCsvText, normalizeCsvHeader } from "./csv.js";

const REQUIRED_BUDGET_COLUMNS = ["category", "irregular", "ongoing"];

function parseBudgetAmount(value) {
  const cleaned = String(value ?? "")
    .replace(/\u20AA/g, "")
    .replace(/ILS/gi, "")
    .replace(/[,\s]/g, "")
    .trim();

  if (!cleaned) {
    return 0;
  }

  const parsed = Number(cleaned);
  if (!Number.isFinite(parsed)) {
    throw new Error(`Invalid budget amount: "${value}"`);
  }

  return parsed;
}

function mapHeaders(headerRow) {
  const headerMap = new Map();

  headerRow.forEach((header, index) => {
    const normalized = normalizeCsvHeader(header);
    if (!normalized) {
      return;
    }

    if (headerMap.has(normalized)) {
      throw new Error(`Duplicate CSV header: "${header}"`);
    }

    headerMap.set(normalized, index);
  });

  return headerMap;
}

function requiredColumnIndexes(headerMap) {
  const missingColumns = REQUIRED_BUDGET_COLUMNS.filter((column) => !headerMap.has(column));
  if (missingColumns.length > 0) {
    throw new Error(`Missing required budget columns: ${missingColumns.join(", ")}`);
  }

  return {
    category: headerMap.get("category"),
    irregular: headerMap.get("irregular"),
    ongoing: headerMap.get("ongoing")
  };
}

export function parseBudgetImportCsv(text) {
  const rows = parseCsvText(text);
  if (rows.length === 0) {
    throw new Error("The selected CSV is empty.");
  }

  const headerMap = mapHeaders(rows[0]);
  const indexes = requiredColumnIndexes(headerMap);
  const rowsByCategory = new Map();

  rows
    .slice(1)
    .forEach((cells) => {
      const category = String(cells[indexes.category] ?? "").trim();
      const irregularBudget = parseBudgetAmount(cells[indexes.irregular]);
      const ongoingBudget = parseBudgetAmount(cells[indexes.ongoing]);

      if (!category) {
        return;
      }

      const normalizedCategory = category.toLocaleLowerCase();
      if (rowsByCategory.has(normalizedCategory)) {
        rowsByCategory.delete(normalizedCategory);
      }

      rowsByCategory.set(normalizedCategory, {
        category,
        irregularBudget,
        ongoingBudget
      });
    });

  return Array.from(rowsByCategory.values());
}
